<div class="p-40">
  <div class="fx-column">
    <div class="fx-row align-items-center justify-content-between">
      <div class="fx-column">
        <span class="page-title">{{'CASE.ADD_PROOFS_TITLE' | translate}}</span>
        <span class="page-subtitle">{{'CASE.ADD_PROOFS_SUBTITLE' | translate}}</span>
      </div>
      <div class="fx-row align-items-center justify-content-end ml-20">
        <button class="button ml-10" (click)="onCancel()" [disabled]="loading" [class.disabled]="loading">
          {{'ACTIONS.CANCEL' | translate}}
        </button>
        <button class="main-button ml-10" (click)="link()" [class.disabled]="isDisabled()" [disabled]="isDisabled()">
          {{'CASE.LINK_PROOFS' | translate}}
        </button>
      </div>
    </div>
  </div>
  <mat-divider class="mv-20"></mat-divider>
  <app-documents-filter-drawer [count]="count" [(filters)]="filters" (filtersChange)="onFilterChange()">
    <div class="ml-10 chip main" slot="header">
      {{this.selection.selected.length}} {{((this.selection.selected.length > 1 ?
      'CASE_DECLARE.SELECTED_DOCUMENTS' :
      'CASE_DECLARE.SELECTED_DOCUMENT') | translate).toLowerCase()}}
    </div>
    <app-documents-table [filteredDocuments]="filteredDocuments" [pager]="pager" (sort)="onSortChange($event)"
      (page)="handlePage($event)" [select]="true" [clickable]="false" [restrictions]="restrictions"
      [(selection)]="selection" />
  </app-documents-filter-drawer>
</div>